import React from "react";
import useDataLoader2 from "../../hooks/useDataLoader2";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import { UseFirmList } from "../../hooks/Catalogs/useFirm";
import { defaultPageSize } from "../../utils/const";
import Filters, {
  IFilterData,
} from "../../components/Catalogs/Filters/Filters";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const AOPRanking: React.FC = ({ ...props }) => {
  const { firmData } = UseFirmList();

  const fields = [
    "id",
    "firm",
    "person",
    "ranks",
    "firmName",
    "personName",
    "rank1Name",
    "rank2Name",
    "rank3Name",
    "rank4Name",
    "_ts",
  ];
  const endpoint = "/AOPRanking";

  const {
    data,
    totalCount,
    fetchData,
    setFilter,
    sort,
    setSort,
    pagination,
    setPagination,
    filter,
    inputFilters,
    setInputFilters,
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "person", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    { 
      id: "count", 
      header: "#", 
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p>
          {rowIndex +
            1 +
            pagination.pageIndex * pagination.pageSize}
        </p>
      )
    },
    { id: "person", header: "Name" },
    { id: "firm", header: "Firm" },
    { id: "rank_1", header: "Rank 1" },
    { id: "rank_2", header: "Rank 2" },
    { id: "rank_3", header: "Rank 3" },
    { id: "rank_4", header: "Rank 4" },
    {
      id: "edit",
      header: "Edit",
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter,
            inputFilters,
          }}
        >
          Edit
          <div className="editsvg">
            <ShapeEdit />
          </div>
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters, firmData]);

  const formatData = (data: any[]) => {
    const formattedData = data.map((d: any) => {
      return {
        ...d,
        rank1: "d.rank1Name",
        rank2: d.rank2Name,
        rank3: d.rank3Name,
        rank4: d.rank4Name,
        person: d.personName,
        firm: d.firmName,
      };
    });
    return formattedData;
  };

  const filtersData: IFilterData[] = React.useMemo(
    () => [
      {
        name: "Name",
        type: "text",
        comparison: "CONTAINS",
      },
      {
        name: "Firm",
        objectData:
          firmData?.map((f: any) => ({ id: f.id, name: f.name })) || [],
      },
    ],
    [firmData]
  );

  return (
    <>
        <CatalogTableC
          title={`AOP Ranking Catalog`}
          catalogName={"RANKINGS"}
          route={"AOPRanking"}
          totalCount={totalCount}
          noNewCatalog
        >
          <Filters
            filtersData={filtersData}
            filterValues={inputFilters}
            setFilterValues={setInputFilters}
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default AOPRanking;
